import { useCallback } from 'react';
import { useNavigate } from 'react-router';
import { openConsoleTab } from '../../lib/consoleNav';
import { useComms } from './context';

/**
 * Navigation to channel-configuration screens (/connect, /inboxes/:id).
 * Standalone: normal in-app navigation. Embedded: a NEW top-level browser tab
 * on the standalone console, signed in through /sso — OAuth consent pages
 * cannot render in an iframe, and config is an admin task that reads fine in
 * its own tab. See `openConsoleTab`, which the framed website pages share.
 */
export function useConfigNav(): (path: string) => void {
  const { source } = useComms();
  const navigate = useNavigate();
  return useCallback(
    (path: string) => {
      if (!source.embedded) {
        navigate(path);
        return;
      }
      openConsoleTab(path);
    },
    [source.embedded, navigate],
  );
}
